import { ITransaction } from './../../models/transaction';
import { ISaleCampaign } from '../../models/sale-campaign';
import { ICustomDataAttribute } from '../../models/custom-data/custom-data-attribute';
import { IProductGroup } from '../../models/product-group';

export namespace SaleCampaign.Actions {
  export class GetCampaigns {
    public static readonly type = '[Campaign] Get Organization Campaigns]';
    constructor(public organizationId: string, public type?: string) {}
  }

  export class GetCampaign {
    public static readonly type = '[Campaign] Get Single Campaign]';
    constructor(public campaignId: string) {}
  }

  export class UpdateCampaign {
    public static readonly type = '[Campaign] Update Single Campaign]';
    constructor(public campaign: ISaleCampaign) {}
  }

  export class DeleteCampaign {
    public static readonly type = '[Campaign] Delete Single Campaign]';
    constructor(public campaign: ISaleCampaign) {}
  }

  export class InsertCampaign {
    public static readonly type = '[Campaign] Insert Single Campaign]';
    constructor(public campaign: ISaleCampaign) {}
  }

  export class GetCampaignOrders {
    public static readonly type = '[Campaign] Get Campaign Orders';
    constructor(public organizationId: string, public campaignId: string) {}
  }

  export class DeleteCampaignOrder {
    public static readonly type = '[Campaign] Delete Single Campaign Order]';
    constructor(public order: ITransaction) {}
  }

  export class GetProductGroups {
    public static readonly type = '[Campaign] Get Product Groups';
    constructor(public organizationId: string) {}
  }

  export class GetProductGroup {
    public static readonly type = '[Campaign] Get Product Group';
    constructor(public productGroupId: string) {}
  }

  export class UpdateProductGroup {
    public static readonly type = '[Campaign] Update Product Group';
    constructor(public productGroup: IProductGroup) {}
  }
  export class InsertProductGroup {
    public static readonly type = '[Campaign] Insert Product Group';
    constructor(public productGroup: IProductGroup) {}
  }
  export class DeleteProductGroup {
    public static readonly type = '[Campaign] Delete Product Group';
    constructor(public productGroup: IProductGroup) {}
  }
}
